/* TODO: t() */
import React from 'react';
import { View, StyleSheet } from 'react-native';

import { RadioContext } from './RadioGroup';
import RadioButton from './RadioButton.web';
import FormField from './FormField';
import Text from './Text';

type Props = {
  title: string;
  value: unknown;
  style?: StyleSet;
  textStyle?: StyleSet;
  tabIndex?: number;
  disabled?: boolean;
  testID?: string;
};

function RadioItem(props: Props) {
  let {
    title,
    value,
    style,
    textStyle,
    tabIndex,
    disabled,
    testID,
    ...otherProps
  } = props;
  return (
    <RadioContext.Consumer>
      {(data) => {
        if (!data) {
          return null;
        }
        let { name, selectedValue, onChange } = data;
        return (
          <FormField
            render={(id) => (
              <View {...otherProps} style={[styles.root, style]}>
                <RadioButton
                  id={id}
                  disabled={disabled}
                  name={name}
                  checked={value === selectedValue}
                  onChange={() => onChange(value)}
                  tabIndex={tabIndex}
                />
                <Text
                  testID={testID}
                  style={[styles.text, textStyle]}
                  type="label"
                  accessibilityRole="label"
                  htmlFor={id}
                >
                  {title}
                </Text>
              </View>
            )}
          />
        );
      }}
    </RadioContext.Consumer>
  );
}

let styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    paddingRight: 15,
    paddingVertical: 8,
  },
  text: {
    paddingLeft: 8,
    fontWeight: 'normal',
  },
});

export default RadioItem;
